import React, { useContext } from 'react';
import { AppContext } from '../context/appContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useContext(AppContext);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'fa' : 'en';
    setLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center justify-center px-3 py-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors duration-200 font-medium text-sm min-w-[50px]"
      title={language === 'en' ? 'Switch to Farsi' : 'Switch to English'}
    >
      {language === 'en' ? 'فا' : 'EN'}
    </button>
  );
};

export default LanguageSwitcher;
